import Member from '../../models/Member.js';

import {validation} from '../../static/js/settingFile/validationData.js';

export default class MemberControllerAPI {

    static index(){
        return new Promise(function(resolve,reject){            
            Member.getAllMembers()
            .then(function(result){
                resolve(result);
            })
            .catch(function(error){
                reject(error);
            });
        })
    }

    static show(id){
        return new Promise(function(resolve,reject) {
            Member.getSpecificMember(id)
            .then(function(result){
                resolve(result);
            })
            .catch(function(error){
                reject(error);
            });
        })
    }

    static store(newMemberData){

        return new Promise(function(resolve,reject){
            //バリデーションチェック
            //名前があるか、文字制限など

            //名前チェック
            if(newMemberData.name.length > validation.memberNameMax){
                //通すけど、制限で切る
                newMemberData.name = newMemberData.name.substr(0,validation.memberNameMax);
            }
            
            //名前なしはダメ
            if(newMemberData.name.length === 0){
                reject({
                    status:false,
                    message:'nameError'
                });

                return;
            }

            //メモチェック
            if(newMemberData.memo.length > validation.memberMemoMax){
                reject({
                    status:false,
                    message:'memoLengthOver'
                });

                return;
            }

            Member.postMember(newMemberData)
            .then(function(result){
                resolve(result);
            })
            .catch(function(error){
                reject(error);
            })
        })
        
    }

    static order_store(membersArray){
        return new Promise(function(resolve,reject){

            Member.orderMember(membersArray)
            .then(function(result){
                resolve(result);
            })
            .catch(function(error){
                reject(error);
            })

        })
    }
    
    // static put(memberData) {
    //     return new Promise(function(resolve,reject){
    //         //バリデーション
    //         console.log('あれー？');
            
            
    //         //名前チェック
    //         if(memberData.name > 30 || memberData.name < 0){
    //             reject({
    //                 status:false,
    //                 message:'nameError'
    //             });
    //         }

    //         //idがあるか
    //         if(memberData.id === undefined){
    //             reject({
    //                 status:false,
    //                 message:'no ID'
    //             });
    //         }

    //         Member.editMember(memberData)
    //         .then(function(result){
    //             resolve(result);
    //         })
    //         .catch(function(error){
    //             reject(error);
    //         })
    //     })
    // }

    static delete(id) {
        return new Promise(function(resolve,reject){
            if(id === undefined){
                reject({
                    status:false,
                    message:'no ID'
                });
            }
            Member.deleteMember(id)
            .then(function(result){
                resolve(result);
            })
            .catch(function(error){
                reject(error);
            })
        })
    }


}